import { render, staticRenderFns } from "./accountCenter.vue?vue&type=template&id=ec31a9ba&scoped=true"
import script from "./accountCenter.vue?vue&type=script&lang=js"
export * from "./accountCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec31a9ba",
  null
  
)

export default component.exports